import _ from 'lodash'
import {exists} from './general'

export const alwaysArray = item => (_.isArray(item) ? item : [item])

export const alwaysDefArray = item => alwaysArray(item).filter(i => _.isBoolean(i) || exists(i))

// these methods do pracitcally the same, but after a while we've discovered we need two utilities:
// 1. a method that filters out all falsy values, that's alwaysDefinedArray (should be alwaysTruthyArray)
// 2. a method that gets out undefined and null, that should be alwaysDefinedArray, but is alwaysDefArray for now.

export const alwaysDefinedArray = item => alwaysArray(item).filter(i => exists(i))
export const alwaysTruthyArray = alwaysDefinedArray
